import React from "react";

export interface ArrowCircleProps {
  width?: number;
  height?: number;
  color?: string;
}

const ArrowCircle: React.FC<ArrowCircleProps> = ({ width = 20, height = 20, color = "#868697" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 7L6 11L14 11L10 7ZM10 -8.74228e-07C11.3833 -7.53293e-07 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.787501 13.9C0.262501 12.6833 7.53293e-07 11.3833 8.74228e-07 10C9.95163e-07 8.61667 0.262502 7.31666 0.787502 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.787499C7.31667 0.2625 8.61667 -9.95163e-07 10 -8.74228e-07ZM10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76666 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2Z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowCircle;
